import { formatParam, parseParam } from "@/utils";
import { useSearchParams } from "react-router-dom";

export function useSearchQuery() {
  const [searchParams] = useSearchParams()
  let result = {}
  for (let entry of searchParams.entries()) {
    result[entry[0]] = entry[1]
  }
  return result
}
export function useSearchParam(key, defaultValue = undefined, type='str', multiple=false) {
  const [searchParams, setSearchParams] = useSearchParams()
  let value = multiple ? searchParams.getAll(key) : searchParams.get(key)

  if (!value) {
    value = defaultValue
  }
  if (multiple) {
    value = value?.map(v => parseParam(v, type))
  } else {
    value = parseParam(value, type)
  }

  if (!value && multiple) {
    value = []
  }

  const setSearchParam = (value, navigateOpts = { replace: false }) => {
    setSearchParams((params) => {
      if (multiple) {
        params.delete(key)
        value?.map(v => {
          params.append(key, formatParam(v, type))
        })
      } else {
        if (value == undefined || value == null) {
          params.delete(key)
        } else {
          params.set(key, formatParam(value, type))
        }
      }
      return params
    }, {
      ...navigateOpts
    })
  }

  return [value, setSearchParam]
}

